export const initialValues = {
    rating: null,
    message: '',
    email: '',
};
